import React, { useCallback, useEffect } from 'react'
import { Grid, Typography } from 'gu-ui-kit'
import { useStories } from 'modules/Stories/hooks/useStories'
import '@splidejs/react-splide/dist/css/splide-core.min.css'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import styles from 'modules/Stories/Stories.module.scss'

const StoriesPreview = ({ className = '' }) => {
  const { fetchList, resetData, sendEvent } = useStories()
  const { i18n } = useSelector(({ app }) => app)
  const dispatch = useDispatch()
  const { data: storiesData } = useSelector(({ stories }) => stories)

  useEffect(() => {
    fetchList({ lang: i18n })
  }, [i18n])

  const handleClick = useCallback((startIndex = 0) => {
    dispatch({
      type: 'MODAL/SHOW',
      payload: {
        modalType: 'stories',
        modalProps: {
          startIndex,
          sendEvent,
          portalClassName: styles['stories__modal-portal'],
          overlayClassName: styles['stories__modal-overlay'],
          breakpoints: {
            0: {
              variant: 'default',
            },
          },
        },
      },
    })
  }, [])

  useEffect(() => () => resetData(), [])

  if (!storiesData.length) {
    return null
  }

  return (
    <div className={clsx(styles['stories'], className)}>
      {/*такой row-gap из-за того что у каждой стори толстый outline по 2.5px => 2.5 * 2 = 5px - прибавляем к желаемому row-gap*/}
      <Grid wrap={false} gap={16} justifyContent={'end'}>
        {storiesData.map(({ id, title, preview_src, stories = [] }, index) => (
          <Grid
            key={id}
            fluid={false}
            alignItems={'end'}
            className={clsx(styles['stories__item'], {
              [styles['stories__item_viewed']]:
                stories.length ===
                stories.filter(({ viewed = false }) => viewed).length,
            })}
            style={{ backgroundImage: `url(${preview_src})` }}
            onClick={() => handleClick(index)}
          >
            <Typography
              className={styles['stories__item-label']}
              variant={'Body-10'}
              color={'Label-Onsurface'}
            >
              {title}
            </Typography>
          </Grid>
        ))}
        <div />
      </Grid>
    </div>
  )
}

StoriesPreview.propTypes = {
  className: PropTypes.string,
}
export default StoriesPreview
